import throttle from "lodash/throttle";

const Header = () => {
	const headerComponent = document.querySelector(".page-header");

	window.addEventListener("scroll", throttle(callbackFunc, 200));

	function callbackFunc() {
		let y = window.pageYOffset;
		if (y > 50) {
			headerComponent.classList.add("scroll");
		} else {
			headerComponent.classList.remove("scroll");
		}
	}

	const toggleBtn = document.querySelector('.toggle-main-nav');
	if (toggleBtn) {
		toggleBtn.addEventListener("click", (event) => {
			if (toggleBtn.classList.contains("is-active")) {
				toggleBtn.classList.remove("is-active");
				document.documentElement.classList.remove("main-nav-open");
			} else {
				toggleBtn.classList.add("is-active");
				setTimeout(() => {
					document.documentElement.classList.add("main-nav-open");
				}, 200);
			}
		});
	}
};

export default Header;
